
import { defineComponent, reactive, computed, PropType, watch, ref, SetupContext } from "vue";
import { useRouter } from "vue-router";
import RequiredLabel from './RequiredLabel.vue'
import type { FormData } from '../types'

type FormStatus = {
  touched?: boolean;
  required?: boolean;
  format?: boolean;
  same?: boolean;
};

type Props = {
  inquiry: FormData
}

export default defineComponent({
  components: {
    RequiredLabel,
  },

  props: {
    inquiry: {
      type: Object as PropType<FormData>,
      default: () => ({}),
    },
  },

  setup(props: Props, context: SetupContext) {
    const router = useRouter();

    let phoneNumber1raw = ''
    let phoneNumber2raw = ''
    let phoneNumber3raw = ''
    if (0 < props.inquiry.phoneNumber.length && /^[0-9]{1,4}-[0-9]{1,4}-[0-9]{1,4}$/.test(props.inquiry.phoneNumber)) {
      const splited = props.inquiry.phoneNumber.split('-');
      phoneNumber1raw = splited[0]
      phoneNumber2raw = splited[1]
      phoneNumber3raw = splited[2]
    }

    const phoneNumber1 = ref<string>(phoneNumber1raw)
    const phoneNumber2 = ref<string>(phoneNumber2raw)
    const phoneNumber3 = ref<string>(phoneNumber3raw)

    const phoneNumber = computed(() => {
      if((phoneNumber1.value.length !== 0) && (phoneNumber2.value.length !== 0) && (phoneNumber3.value.length !== 0)){
        return `${phoneNumber1.value}-${phoneNumber2.value}-${phoneNumber3.value}`
      }
      else return ''
    })

    // const formData = reactive<FormData>(props.inquiry);
    const formData = reactive<FormData>({...props.inquiry, phoneNumber:phoneNumber.value});

    const formStatuses = reactive<{
      companyName: FormStatus;
      name: FormStatus;
      nameKana: FormStatus;
      phoneNumber: FormStatus;
      phoneNumber1: FormStatus;
      phoneNumber2: FormStatus;
      phoneNumber3: FormStatus;
      email: FormStatus;
      inquiryType: FormStatus;
    }>({
      companyName: { touched :false },
      name: { touched :false },
      nameKana: { touched :false },
      phoneNumber: {},
      phoneNumber1: { touched :false },
      phoneNumber2: { touched :false },
      phoneNumber3: { touched :false },
      email: { touched :false },
      inquiryType: {}
    });

    const phoneNumberAllTouched = computed(() => formStatuses.phoneNumber1.touched && formStatuses.phoneNumber2.touched && formStatuses.phoneNumber3.touched)

    const isValidPhoneNumber = (phoneNumber: string) => {
      const regExp = /^[0-9]{1,4}-[0-9]{1,4}-[0-9]{1,4}$/;
      return regExp.test(phoneNumber);
    };
    const isValidEmail = (email: string) => {
      const regExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regExp.test(email);
    };

    const validateAll = () => {
      formStatuses.companyName.required = formData.companyName.length !== 0;
      formStatuses.name.required = formData.name.length !== 0;
      formStatuses.nameKana.required = formData.nameKana.length !== 0;
      formStatuses.phoneNumber.required = phoneNumber.value.length !== 0;
      formStatuses.email.required = formData.email.length !== 0;
      formStatuses.inquiryType.required = formData.inquiryType.length !== 0;

      formStatuses.phoneNumber.format = isValidPhoneNumber(phoneNumber.value);
      formStatuses.email.format = isValidEmail(formData.email);

      const allValid = Object.values(formStatuses).every((formElement) =>
        [formElement.required, formElement.format, formElement.same].every((elm) => typeof elm === 'undefined' || elm)
      );

      return allValid;
    };

    watch(formData, () => validateAll())
    watch(phoneNumber, () => validateAll())

    const confirm = () => {
      if (!validateAll()) {
        setTimeout(() => {
          document
            .querySelector(".error_form")
            ?.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 100);
        return false;
      }

      context.emit('update-inquiry-data', {
        ...formData,
        phoneNumber: phoneNumber.value
      })

      router.push({path: "/confirm"});
    };

    // validatoin状況初期化の為に一度呼び出す
    validateAll()

    return {
      phoneNumber1,
      phoneNumber2,
      phoneNumber3,
      phoneNumber,
      phoneNumberAllTouched,
      formData,
      formStatuses,
      touched: {
        companyName: false,
        name: false,
        nameKana: false,
        phoneNumber: false,
        email: false,
        emailConfirmation: false,
      },
      confirm,
    };
  },
});
